import React from 'react';
import { Link } from 'react-router-dom';
import LogoMark from './Logo';
import { ArrowUp, GitHub, LinkedIn } from './Icons';
import { CONTACT, NAV_LINKS, SERVICES, SOCIAL } from '../data/content';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-statement" aria-hidden="true">
          Different wiring.
          <br />
          <span className="highlight">Brilliant software.</span>
        </div>

        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo" aria-label="Autistic Dev home">
              <LogoMark />
              <span>
                autistic<span className="highlight">.</span>dev
              </span>
            </Link>
            <p>Empowering Innovation with Diversity. A neurodiverse studio building technology everyone can use.</p>
            <div className="social-links">
              <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" aria-label="Autistic Dev on LinkedIn">
                <LinkedIn />
              </a>
              <a href={SOCIAL.github} target="_blank" rel="noopener noreferrer" aria-label="Autistic Dev on GitHub">
                <GitHub />
              </a>
            </div>
          </div>

          <nav aria-label="Footer">
            <h3>Explore</h3>
            <ul>
              {NAV_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3>Services</h3>
            <ul>
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link to="/services">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3>Say hello</h3>
            <ul>
              <li>
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
              <li>
                <Link to="/contact">Start a project →</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {year} Autistic Dev. All rights reserved.</p>
          <button
            type="button"
            className="back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            Back to top <ArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
